// API de "Transmitir en vivo" (vivo-redes). Vive en el Editor (editor.lisual.com/api/vivo-redes/*), que es
// donde están las cámaras en vivo (Neolink). Se autentica con el mismo token corto del widget de ayuda:
// lisual-admin-backend lo firma (POST /api/auth/widget-token) con la sesión de LisualPro.
// En local: REACT_APP_WIDGET_API_BASE / REACT_APP_WIDGET_TOKEN_URL (servidor de prueba widget-dev, :8094).

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8081";
const TOKEN_URL = process.env.REACT_APP_WIDGET_TOKEN_URL || `${BACKEND_URL}/api/auth/widget-token`;
export const VIVO_REDES_BASE = (process.env.REACT_APP_VIVO_REDES_URL
  || (process.env.NODE_ENV === "development" && process.env.REACT_APP_WIDGET_API_BASE)
  || "https://editor.lisual.com") + "/api/vivo-redes";

const tokens = new Map(); // feedId -> { token, vence }

async function tokenPara(feedId, empresa) {
  const t = tokens.get(feedId);
  if (t && t.vence > Date.now()) return t.token;
  const auth = localStorage.getItem("authLisualToken");
  if (!auth) throw new Error("Tu sesión venció. Volvé a entrar.");
  // fetch y no el axios con interceptor: un error acá nunca tiene que cerrar la sesión de LisualPro
  const res = await fetch(TOKEN_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${auth}` },
    body: JSON.stringify({ feedId, ...(empresa && empresa.customerId ? empresa : {}) }),
  });
  if (!res.ok) throw new Error("No pudimos validar tu sesión. Recargá la página.");
  const data = await res.json();
  tokens.set(feedId, { token: data.token, vence: Date.now() + Math.max(60, (data.expiresIn || 600) - 60) * 1000 });
  return data.token;
}

async function pedir(metodo, ruta, { feedId, empresa, body } = {}) {
  const token = await tokenPara(feedId, empresa);
  const sep = ruta.includes("?") ? "&" : "?";
  const url = `${VIVO_REDES_BASE}/${ruta}${metodo === "GET" ? `${sep}feedId=${encodeURIComponent(feedId)}` : ""}`;
  const res = await fetch(url, {
    method: metodo,
    headers: { "Content-Type": "application/json", Authorization: `Widget ${token}` },
    body: body ? JSON.stringify({ feedId, ...body }) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch (e) { /* sin cuerpo */ }
  if (res.status === 401) tokens.delete(feedId);
  if (!res.ok || data.ok === false) {
    const err = new Error(data.error || "No pudimos conectar con el servidor. Probá de nuevo.");
    err.data = data;
    err.status = res.status;
    throw err;
  }
  return data;
}

export const getConfig = (feedId, empresa) => pedir("GET", "config", { feedId, empresa });
export const getEstado = (feedId, empresa) => pedir("GET", "status", { feedId, empresa });
export const salirEnVivo = (feedId, empresa, body) => pedir("POST", "start", { feedId, empresa, body });
export const cortar = (feedId, empresa) => pedir("POST", "stop", { feedId, empresa, body: {} });
export const borrarDestino = (feedId, empresa, id) => pedir("POST", `destinos/${encodeURIComponent(id)}/borrar`, { feedId, empresa, body: {} });
export const musicaUrl = (rel) => `${VIVO_REDES_BASE}/${rel}`;
